import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { KPIDashboardService } from '~lmo/kpidashboard/kpidashboard.service';
import { trackById } from '~utilities/trackById';

@Component({
  selector: 'sa-timeframe-selector',
  templateUrl: './timeframe-selector.component.html',
})
export class TimeFrameSelectorComponent implements OnInit {
  @Input() public timeframes = [30, 60, 90, 120];
  @Input() public default = 30;
  @Output() public newItemEvent = new EventEmitter<number>();
  public selectedTimeframe: number | null;
  public regionID: number;
  public fracsID: number[];

  constructor(private kpiDashboardService: KPIDashboardService) {}

  public readonly trackById = trackById;

  public ngOnInit(): void {
    this.selectedTimeframe = this.default;

    this.kpiDashboardService.regionID$.subscribe((regionID) => {
      if (regionID) {
        this.regionID = regionID;
      }
    });

    this.kpiDashboardService.fracsID$.subscribe((fracsID) => {
      if (fracsID.length > 0) {
        this.fracsID = fracsID;
      }
    });
  }

  public setTimeframe(timeframe: number): void {
    this.newItemEvent.emit(timeframe);
    this.kpiDashboardService.setTimeframe(timeframe);
    this.selectedTimeframe = timeframe;
  }
}
